// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,

  // apiserver : "http://kcwscbackend.slrobotics.org:4000"
  //apiserver : "http://localhost:4000"
  // apiserver : "http://localhost:8000"
  // apiserver : "https://unicoan.com/kcwsc-demo-backend/public"
  apiserver : "https://kcwscbackend.slrobotics.org/public"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts